module.exports = __webpack_public_path__ + "static/media/sf-trial-1-wrong.08d89bb1.mp3";